const ChevronDown = () => (
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 15.075L6 9.075L7.075 8L12 12.95L16.925 8.025L18 9.1L12 15.075Z" fill="black"/>
    </svg>
)

export default ChevronDown;